import React, { ReactElement } from "react";
import { ToelichtingArbeidsongeschiktheidHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../../../components/Chapter";
import { Paragraph } from "../../../components/Paragraph";
import Heading from "../../../components/Heading";
import { PageBreak } from "../../../components/PageBreak";
import { ScenarioArbeidsongeschiktheidChapter } from "./scenario-arbeidsongeschiktheid-chapter";

type ToelichtingArbeidsongeschiktheidChapterProps = {
  hoofdstuk: ToelichtingArbeidsongeschiktheidHoofdstuk;
};

export const ToelichtingArbeidsongeschiktheidChapter = ({
  hoofdstuk,
}: ToelichtingArbeidsongeschiktheidChapterProps): ReactElement => {
  return (
    <>
      <PageBreak />
      <Chapter>
        <Heading level={2} text={hoofdstuk.titel} />
        <Paragraph paragraaf={hoofdstuk.paragrafen?.p3060401} />
        {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 1) && (
          <ScenarioArbeidsongeschiktheidChapter
            scenarioArbeidsongeschiktheid={hoofdstuk}
            selectedAanvrager="Aanvrager1"
          />
        )}
        {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 2) && (
          <>
            {hoofdstuk.motivering?.some((x) => x.klantVolgnummer === 1) && (
              <PageBreak />
            )}
            <ScenarioArbeidsongeschiktheidChapter
              scenarioArbeidsongeschiktheid={hoofdstuk}
              selectedAanvrager="Aanvrager2"
            />
          </>
        )}
      </Chapter>
    </>
  );
};
